import { Modal, Button } from "antd";
import { logout } from "../utils/auth";
import "./UserInfoModal.css";

const UserInfoModal = ({ isOpen, onClose, user }) => {
  const handleLogout = () => {
    onClose();
    logout();
  };

  return (
    <Modal
      title="접속 계정"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      mask={false}
      closable
      width={268}
      className="user-info-modal"
      style={{
        position: "fixed",
        top: 75,
        right: 24,
        margin: 0,
      }}
      styles={{
        container: {
          padding: 0,
        },
        body: {
          paddingTop: 0,
          paddingLeft: 16,
          paddingRight: 16,
          paddingBottom: 24,
        },
      }}
    >
      <div className="modal-user-info">
        <div className="modal-user-name">{user?.name || "-"}</div>
        <div className="modal-user-auth">
          {user?.auth !== undefined ? user.auth : "-"}
        </div>
        <Button
          type="primary"
          size="large"
          onClick={handleLogout}
          className="modal-logout-button"
          block
          style={{ background: "#003D48" }}
        >
          로그아웃
        </Button>
      </div>
    </Modal>
  );
};

export default UserInfoModal;
